import * as React from "react"
import * as noUiSlider from 'nouislider'
import './input-range.component.css'

interface Props {
  start?: number | number[]
  range?: { min: number, max: number }
  step?: number
  snap?: boolean,
  margin?: number
  connect?: boolean
  tooltips?: boolean
  tooltipsInvisible?: boolean
  onChange: (value: number, handle: number) => void
  className?: string,
  format?: { from: (_: string) => number, to: (_: number) => string }
}

export default function InputRangeComponent ({ 
  start = 0, 
  step = 1, 
  connect = false, 
  tooltips = false, 
  tooltipsInvisible = false, 
  format, 
  range, 
  margin, 
  snap,
  className,
  ...otherProps
}: Props)  {
  const ref = React.useRef<HTMLDivElement>()
  const slider = React.useRef<noUiSlider.API>()

  const onChangeRef = React.useRef<typeof otherProps.onChange>()

  React.useEffect(() => {
    onChangeRef.current = otherProps.onChange
  }, [otherProps.onChange])

  const onChange = React.useCallback((handle: number, numericValues: number[]) => {
    const previousValue = Array.isArray(start) ? start[handle] : start
    if (onChangeRef.current && numericValues[handle] !== previousValue) onChangeRef.current(numericValues[handle], handle)
  }, [start])

  React.useEffect(() => { 
    const formattedStart = typeof start === 'undefined' || !format ? start : (Array.isArray(start) ? start.map(format.to) : format.to(start))
    slider.current = noUiSlider.create(ref.current, { start: formattedStart as any, range, margin, step, snap, connect, tooltips, format })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (slider.current) slider.current.on('update', (_, handle, numericValues) => onChange(handle, numericValues))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChangeRef])

  React.useEffect(() => {
    slider.current.updateOptions({ range, step, margin }, false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step])

  return <div ref={ ref } className={ `noUi-container ${tooltipsInvisible ? 'noUi--invisibleTooltip' : ''} ${className}` }></div>
}
